import { Icon } from '@eventbrite/eds-icon';
import { gettext } from '@eventbrite/i18n';
import React from 'react';
import { Fire } from './icons/Fire';
import { Megaphone } from './icons/Megaphone';
import { useUrgencyMessages } from './provider';
import { UrgencyMessageType } from './types';
import './UrgencyMessages.scss';

export type UrgencyMesssagesProps = {
    type: UrgencyMessagesTypes;
};

export enum UrgencyMessagesTypes {
    hurry = 'hurry',
    info = 'info',
}

export const UrgencyMessage: React.FC<UrgencyMesssagesProps> = ({
    children,
    type,
}) => {
    return (
        <div className={`urgency-message urgency-message--${type}`}>
            {children}
        </div>
    );
};

export const UrgencyMessageHurry: React.FC = ({ children }) => (
    <UrgencyMessage type={UrgencyMessagesTypes.hurry}>
        <Icon type={<Fire />} size="xsmall" />
        {children}
    </UrgencyMessage>
);

export const FewTicketsLeft = () => (
    <UrgencyMessageHurry>{gettext('Few tickets left')}</UrgencyMessageHurry>
);

export const GoingFast = () => (
    <UrgencyMessageHurry>{gettext('Going fast')}</UrgencyMessageHurry>
);

export const TicketSalesEndSoon = () => (
    <UrgencyMessage type={UrgencyMessagesTypes.info}>
        <Icon type={<Megaphone />} size="small" />
        {gettext('Ticket sales end soon')}
    </UrgencyMessage>
);

export const UrgencyMessages: React.FC = () => {
    const values = useUrgencyMessages();

    return (
        <>
            {values[UrgencyMessageType.GoingFast] && <GoingFast />}
            {values[UrgencyMessageType.FewTickets] && <FewTicketsLeft />}
            {values[UrgencyMessageType.SalesEndSoon] && <TicketSalesEndSoon />}
        </>
    );
};
